import React, { useState } from 'react';
import { Wrapper, Patent, PatentTitle, PatentBody, Description, PatentFooter, DetailsLink, PatentsSection, ImageContainer, Image, Content } from './index.styled';
import { useTranslation } from 'react-i18next';
import { ModalProvider } from 'styled-react-modal';
import { PortfolioDetailModal } from '../PortfolioDetailModal';

import Fade from 'react-reveal/Fade';

export const TopPortfolios = ({ name }) => {
  const { t } = useTranslation();
  const portfolioCategories = t(`PortfolioCategories`, { returnObjects: true });
  const [category] = portfolioCategories.filter(category => category.name === name)
  const portfolios = category.portfolios
  const topPortfolios = portfolios.slice(0, 2);
  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState(null);
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  
  const toggleModal = ({ target }) => {
    const value = target.getAttribute('value')
    //eslint-disable-next-line array-callback-return
    const data = portfolios.find((portfolio) => {
      if (portfolio.title === value) {
        portfolio.sectionName = name;
        return portfolio;
      }
    })
    setModalData(data)
    setOpenModal(!openModal)
  }

  

  return (
    <Wrapper>
      <PatentsSection>
        <Fade up >
        {
          topPortfolios.map((portfolio, index) => (
              <Patent ie={isIE.toString()} key={portfolio.title}>
                <ImageContainer>
                  <Image src={`${portfolio.image}`} alt={portfolio.title} />
                </ImageContainer>
                <Content>
                  <PatentTitle>
                    {portfolio.title}
                  </PatentTitle>
                  <PatentBody>
                    <Description>
                      {(portfolio.longDescription.length > 255) ? portfolio.longDescription.replace(/<br\/><br\/>/g, ' ').substr(0, 244) + '\u2026' : portfolio.longDescription.replace(/<br\/><br\/>/g, ' ')}
                    </Description>
                  </PatentBody>
                  <PatentFooter>
                    <DetailsLink onClick={(e) => toggleModal(e)} value={portfolio.title}>
                      {portfolio.details.content}
                    </DetailsLink>
                  </PatentFooter>
                </Content>
              </Patent>

          ))
          }
        </Fade>
      </PatentsSection>
      <ModalProvider>
        {openModal && <PortfolioDetailModal updateModal={setOpenModal} data={modalData} openModal={openModal} />}
      </ModalProvider>
    </Wrapper>
  )
}